import './bootstrap';
import * as Turbo from '@hotwired/turbo';
import Cookies from 'js-cookie';
import Pages from './modules/pages';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import Scrollbar from 'smooth-scrollbar';

//$(document).ready(function () {
//});



let pageLoadCount = 0;
let pages = new Pages();

Turbo.start();

// Always show progress bar
Turbo.setProgressBarDelay(0);

/**
 * Set a cookie to say if this is the first load or not
 *
 * We do some funky business where we hide the page contents until the first resize event is fired. This is to prevent
 * the page from loading at the wrong size on mobile devices & jumping around a bit during the first resize. We then fade
 * in the page contents. After an initial load we set this cookie so the backend knows it's not a first load & can include
 * an additional class on the body tag to prevent the page from being hidden at first.
 *
 * @type {number}
 */
let notFirstLoad = 0;
setInterval(setNotFirstLoad, 10000);
function setNotFirstLoad() {
    notFirstLoad++;
    Cookies.set('notFirstLoad', notFirstLoad, {expires: 0.00013});
    //console.log('set notFirstLoad cookie');
}
setNotFirstLoad();

/**
 * Browser fingerprint
 */
const fpPromise = FingerprintJS.load();

// Get the visitor identifier when you need it.
fpPromise.then(fp => fp.get())
    .then(result => {
        // This is the visitor identifier:
        const visitorId = result.visitorId
        Cookies.set('fp', visitorId, {expires: 1});
    })

/**
 * If we need to unload/destroy any JS before the page is cached by turbo as they'll be done again on load & we
 * might double up inits
 */
document.addEventListener("turbo:before-cache", function () {
    $(window).off('resize');
    $('.button, a').off('click');
})


document.addEventListener("turbo:load", function () {
    pageLoadJs();
    if ($('#main').length) {
        if ($('#main').data('type') == 'page' && $('#main').data('page')) {
            pages.in($('#main').data('page'));
        }
    }
});


document.addEventListener("turbo:before-render", async (event) => {

    console.log('turbo:before-render', event, event.detail);

    //if (document.documentElement.hasAttribute('data-turbo-preview')) {
        event.preventDefault();
        //console.log('turbo:before-render');
        await pages.out($('#main').data('page'));
        event.detail.resume();
    //}
})


document.addEventListener("turbo:before-visit", function () {
    /*
    if ($('#mobile-slide-nav:visible').length) {
        $('#mobile-slide-nav').slideUp(200);
    }
     */
});


function pageLoadJs() {
    console.log('pageLoadJs()');



    pageLoadCount++;

    var animatedDotsTimer = null;

    let scrollElement = document.querySelector('.v-scroll');
    console.log('scrollElement', scrollElement);
    if (scrollElement) {
        Scrollbar.init(scrollElement, {
            "alwaysShowTracks": true
        });
        //Scrollbar.initAll();
    }



    if (!isBrowserCompatible() && !window.location.href.includes('browser-compatibility')) {
        location.href = '/browser-compatibility';
    }

    function isBrowserCompatible() {

        // Don't support Safari below V13
        const userAgent = navigator.userAgent;
        const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
        console.log('isSafari', isSafari, userAgent);
        if (isSafari) {
            const versionMatch = userAgent.match(/Version\/([\d\.]+)/);
            if (versionMatch && versionMatch.length > 1) {
                const version = parseFloat(versionMatch[1]);
                if (version < 13) {
                    // Safari version is below 13
                    console.log("Detected Safari version below 13: " + version);
                    return false;
                }
            }
        }

        return true;
    }


    $(function () {
        // Any jQuery stuff here...
        console.log('jQuery Ready');

        // Manage resizing content
        var minWidth = 414;
        var minHeight = 736;

        $(window).resize(function (e) {

            if ($('body').hasClass('bootstrap')) {
                $("body, html").css('font-size', '16px');
            } else {
                var windowWidth = window.innerWidth;
                var windowHeight = window.innerHeight;
                /*
                if (document.body.clientHeight && document.body.clientHeight < windowHeight) {
                    windowHeight = document.body.clientHeight;
                }
                 */

                // Calculate scales based on the window dimensions and the minimum dimensions
                var scaleWidth = windowWidth / minWidth;
                var scaleHeight = windowHeight / minHeight;

                // Choose the smaller scale to ensure that .inner fits within both dimensions
                var scale = Math.min(scaleWidth, scaleHeight);
                $("body, html").css('font-size', scale + 'px');
                //console.log('scale', scale, scaleWidth, scaleHeight);
            }

            let displayType = 'portrait';
            $('body').removeClass('portrait');
            $('body').removeClass('landscape');
            if (window.innerWidth > window.innerHeight) {
                displayType = 'landscape';
            }
            $('body').addClass(displayType);
            //console.log('!! displayType !!', displayType, window.innerWidth, window.innerHeight, document.body.clientHeight);

            $('body').addClass('not-first-load');




            // Calculate the aspect ratio
            let screenWidth = window.innerWidth;
            let screenHeight = window.innerHeight;
            let aspectRatio;
            if (screenWidth > screenHeight) {
                aspectRatio = (screenWidth / screenHeight).toFixed(2);
            } else {
                aspectRatio = (screenHeight / screenWidth).toFixed(2);
            }
            let aspectType = 'taller';
            $('body').removeClass('taller');
            $('body').removeClass('wider');
            if (aspectRatio < 1.78) {
                aspectType = 'wider';
            }
            $('body').addClass(aspectType);
        });
        $(window).trigger('resize');


        $('.back-btn-page').click(function (e) {

            let href = $(this).attr('href');
            if (href && href !== '#') {
                return window.location = href;
            }

            e.preventDefault();
            window.history.back();
        });


        $('a').click((e) => {
            lastLinkNotes = e.currentTarget.dataset.clicknotes;
            if (lastLinkNotes && lastLinkNotes !== 'undefined') {
                console.log('lastLinkNotes', lastLinkNotes);
            }
        });


        // Force a quick tough to trigger a full hover animation
        $('.button, a').on('touchstart click', function () {
            if (!$(this).hasClass('no-active')) {
                $(this).addClass('active');
                var that = this;
                setTimeout(function () {
                    $(that).removeClass('active');
                }, 300);
            }
        })


        function animated_dots() {
            clearInterval(animatedDotsTimer);
            var dots = 1;
            animatedDotsTimer = setInterval(function () {
                dots++;
                if (dots > 3) {
                    dots = 1;
                    $(".dots").text(".");
                }
                if (dots === 2) {
                    $(".dots").text("..");
                }
                if (dots === 3) {
                    $(".dots").text("...");
                }
            }, 500);
        }
        animated_dots();

        if ($(".dots").length) {

        }
    });

}

